module.exports = __webpack_public_path__ + "img/2024-1.75eeae44.jpg";